function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-13,.cls-14,.cls-15,.cls-2,.cls-5{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke:#e5e5e5;stroke-width:3.06px;}.cls-3{fill:#777;}.cls-4,.cls-9{fill:#8ce08c;}.cls-5{stroke:#2f855a;stroke-width:3.65px;}.cls-6{fill:#ed8936;}.cls-7{fill:#2f855a;}.cls-8{fill:#c2c2c2;}.cls-9{fill-rule:evenodd;}.cls-10{fill:#fefddb;}.cls-11{fill:#81e6d9;opacity:0.75;}.cls-12{fill:#fff;}.cls-13{stroke:#ed8936;stroke-width:3px;}.cls-14{stroke:#81e6d9;stroke-width:5.14px;}.cls-15{stroke:#fff;stroke-width:16px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M499.3,264.27c52.83,78.54,92.1,155.35,91.63,249.19-.63,94-41.16,204.87-120,247-79,42.27-196.2,15.61-285.62-38.8-89.42-54.57-150.93-137-172.7-229.47S8.81,297.39,65.74,217.9,218.41,81.8,299.32,93.62,446.46,185.57,499.3,264.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M521,199.25,301,471.19l395.74,99.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M347.46,398.93C318.91,428.18,223,536.36,223.78,563.49s275.1,92.82,275.1,92.82V615.82l-59.14-26.38L347.55,400.16"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 424.58,
  cy: 105.69,
  r: 40.48
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M396.61,98.28c-.55-4.14.56-7.71,2.49-8s3.94,2.89,4.49,7-.55,7.71-2.48,8S397.17,102.42,396.61,98.28Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "415.57 171.7 283.2 400.16 526.04 348.62 415.57 171.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "409.94 0 384.1 55.78 445.32 50.26 409.94 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M399.33,816.76c-14,0-48.8,1.74-70.69,38.89H429.57V816.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M496.38,646.08c0,14,1.74,48.8,38.89,70.69V615.84H496.38Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "347.46 398.93 484.59 370.71 429.57 816.76 380.45 821.3 347.46 398.93"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M452.5,429.6a34.32,34.32,0,1,1,34.32,34.32A34.33,34.33,0,0,1,452.5,429.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M158.33,215a34.32,34.32,0,1,1,34.31,34.31A34.31,34.31,0,0,1,158.33,215Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 3.28,
  y: 96.4,
  width: 262.34,
  height: 89.06,
  transform: "translate(-11.39 11.82) rotate(-4.83)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 14.91,
  y: 154.69,
  width: 69.68,
  height: 22.58,
  transform: "translate(-13.8 4.78) rotate(-4.83)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 0.19,
  y: 96.53,
  width: 262.34,
  height: 15.59,
  transform: "translate(-8.32 11.43) rotate(-4.83)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 210.82,
  cy: 141.04,
  r: 19.13
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "219.48 140.31 205.86 133.91 207.13 148.91 219.48 140.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "52.01 57.75 38.33 64.03 50.62 72.73 52.01 57.75"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 12.48,
  y1: 138.61,
  x2: 160.43,
  y2: 126.1
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 222.06,
  y: 19.67,
  width: 64.69,
  height: 64.69,
  rx: 15.68,
  transform: "translate(18.26 -55.99) rotate(13.02)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 293.22,
  cy: 27.79,
  r: 12.55
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-14",
  cx: 107.14,
  cy: 237.31,
  r: 12.55
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M253.38,37.61,237.83,54.28a4.9,4.9,0,0,0,2.48,8.12l22.21,5.14a4.91,4.91,0,0,0,5.8-6.21l-6.66-21.81A4.9,4.9,0,0,0,253.38,37.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M138.9,27.56V45.64A3.88,3.88,0,0,0,144.73,49l15.65-9a3.89,3.89,0,0,0,0-6.74l-15.65-9A3.89,3.89,0,0,0,138.9,27.56Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 389.37,
  y1: 216.93,
  x2: 433.91,
  y2: 201.08
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 361.62,
  y1: 264.82,
  x2: 453.34,
  y2: 232.19
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 333.87,
  y1: 312.72,
  x2: 472.77,
  y2: 263.3
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 306.11,
  y1: 360.62,
  x2: 492.2,
  y2: 294.42
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 329.41,
  y1: 390.36,
  x2: 511.62,
  y2: 325.53
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-15",
  x1: 393.25,
  y1: 240,
  x2: 359.9,
  y2: 297.56
})));

var SvgWatermelonPackIllustration05 = function SvgWatermelonPackIllustration05(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 698.28 855.65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration05, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-05.df177da4.svg";
export { ForwardRef as ReactComponent };